import { jsx as t } from "react/jsx-runtime";
import i from "react";
import { c as e } from "../../cn-gv_k3DnN.js";
const m = i.forwardRef(
  ({ children: a, className: r, ...n }, o) => /* @__PURE__ */ t(
    "div",
    {
      ref: o,
      className: e(
        // Base
        "mx-auto w-full",
        // Container has max-width (1176px + padding) with responsive padding
        // that scales from 20px to 90px based on viewport width (5vw)
        "max-w-[calc(var(--container-max-width)+2*var(--container-padding))] px-[var(--container-padding)]",
        r
      ),
      ...n,
      children: a
    }
  )
);
m.displayName = "Container";
export {
  m as Container
};
